<ng-container
    *im2mLet="{
        loading: loading$ | async,
        devices: devices$ | async,
        filterParams: filterParams$ | async,
        count: deviceCount$ | async,
        loggedInUser: loggedInUser$ | async,
        tenants: tenants$ | async
    } as data"
>
    <liebherr-table-controls [title]="'DEVICES.TITLE'" [filterGroups]="filterGroups$ | async">
        <button *ngIf="data.loggedInUser | liebherrPermission : getDevicePermissions('addDevice')" mat-icon-button (click)="onAddDevice()">
            <mat-icon>add</mat-icon>
        </button>
    </liebherr-table-controls>
    <liebherr-loading *ngIf="data?.loading === true"></liebherr-loading>

    <liebherr-table-container liebherrTableConfig #tableConfig="liebherrTableConfig" [columnGroups]="columnGroups">
        <liebherr-column-toggle [tableConfig]="tableConfig" buttonType="icon" [useCheckboxes]="true" selectorColor="primary" buttonIcon="expand_more"></liebherr-column-toggle>

        <table
            mat-table
            [dataSource]="data?.devices"
            matSort
            *im2mLet="tableConfig.displayedColumns$ | async as displayedColumns"
            [matSortActive]="data?.filterParams?.sortColumn"
            [matSortDirection]="data?.filterParams?.sortAsc ? 'asc' : 'desc'"
            (matSortChange)="routerService.setSortParams($event)"
        >
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column" [sticky]="column === COLUMNS.SERIAL_NUMBER" [stickyEnd]="column === COLUMNS.ACTIONS">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear [disabled]="columnsWithSorting.indexOf(column) === -1">
                    <ng-container *ngIf="column === COLUMNS.ONLINE">
                        <mat-icon>wifi</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="column !== COLUMNS.ONLINE && column !== COLUMNS.ACTIONS">
                        {{ 'DEVICES.COLUMNS.' + (column | uppercase) | transloco }}
                    </ng-container>
                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container [ngSwitch]="column">
                        <!--SERIAL / IMEI-->
                        <ng-container *ngSwitchCase="COLUMNS.SERIAL_NUMBER">
                            <a class="main-val" [href]="element | liebherrM2MGateUrl" target="_blank">{{ element.serialNumber || '-' }}</a>
                            <span class="sub-val">{{ element.id || '-' }}</span>
                        </ng-container>
                        <!-- ROUTER_TYPE -->
                        <ng-container *ngSwitchCase="COLUMNS.ROUTER_TYPE">
                            {{ element.routerType?.name || '-' }}
                        </ng-container>
                        <!--CONNECTION-->
                        <ng-container *ngSwitchCase="COLUMNS.ONLINE">
                            <liebherr-connection-state [device]="element"></liebherr-connection-state>
                        </ng-container>
                        <!-- LINK -->
                        <ng-container *ngSwitchCase="COLUMNS.LINK">
                            <liebherr-link-state [device]="element"></liebherr-link-state>
                        </ng-container>
                        <!-- SIM CARD EXPIRATION DATE -->
                        <ng-container *ngSwitchCase="COLUMNS.SIM_CARD_EXPIRATION_DATE">
                            {{ element.simcardInfo?.expirationDate ? (element.simcardInfo?.expirationDate | date : ('DATE_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <!-- VPN IP -->
                        <ng-container *ngSwitchCase="COLUMNS.VPN_IP">
                            {{ element.vpnInfo?.vpnIp || '-' }}
                        </ng-container>
                        <!-- CERTIFICATE -->
                        <ng-container *ngSwitchCase="COLUMNS.C_COMBINED">
                            <liebherr-certificate-state [device]="element"></liebherr-certificate-state>
                        </ng-container>
                        <!-- FIRMWARE -->
                        <ng-container *ngSwitchCase="COLUMNS.FW_COMBINED">
                            <liebherr-firmware-state [device]="element"></liebherr-firmware-state>
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.ACTIONS">
                            <liebherr-action-menu (action)="onActionMenuClick($event, element)">
                                <liebherr-action-menu-item
                                    *ngFor="let item of element.menuItems"
                                    [item]="{
                                        label: item.label,
                                        event: item.event
                                    }"
                                    [disabled]="!item.active"
                                >
                                </liebherr-action-menu-item>
                            </liebherr-action-menu>
                        </ng-container>
                        <!--STATE TIME-->
                        <ng-container *ngSwitchCase="COLUMNS.STATE_TIME">
                            <ng-container *ngIf="element.vpnInfo?.statusTime; else timeELse"></ng-container>
                            <span class="main-val">{{ element.vpnInfo?.statusTime | liebherMarkAsUTC | date : ('DATE_FORMAT' | transloco) }}</span>
                            <span class="sub-val">{{ element.vpnInfo?.statusTime | liebherMarkAsUTC | date : ('TIME_FORMAT' | transloco) }}</span>
                            <ng-template #timeELse>-</ng-template>
                        </ng-container>
                        <!-- OTHER COLUMNS -->

                        <ng-container *ngSwitchCase="COLUMNS.CONNECTED_USER">
                            {{ element?.vpnInfo?.currentUser || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.CRANE_ID">
                            {{ element.craneId || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.C_FETCHED_TIME">
                            {{ element.certificateInfo?.fetchedTime ? (element.certificateInfo?.fetchedTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.C_GRANTED_BY">
                            {{ element.certificateInfo?.grantedBy || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.C_GRANTED_TIME">
                            {{ element.certificateInfo?.grantedTime ? (element.certificateInfo?.grantedTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.C_GRANTED_UNTIL">
                            {{ element.certificateInfo?.grantedUntil ? (element.certificateInfo?.grantedUntil | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.TENANT">
                            {{ element.servicePath | liebherrTenantNameByPath : data?.tenants }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.C_REQUEST_TIME">
                            {{ element.certificateInfo?.requestTime ? (element.certificateInfo?.requestTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.FW_DOWNLOAD_ALLOWED_TIME">
                            {{ element.fwUpdateInfo?.downloadAllowedTime ? (element.fwUpdateInfo?.downloadAllowedTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.FW_DOWNLOAD_TIME">
                            {{ element.fwUpdateInfo?.downloadTime ? (element.fwUpdateInfo?.downloadTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.FW_DOWNLOAD_ALLOWED_BY">
                            {{ element.fwUpdateInfo?.downloadAllowedBy || '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.FW_INSTALLED_TIME">
                            {{ element.fwUpdateInfo?.installedTime ? (element.fwUpdateInfo?.installedTime | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco)) : '-' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.ROUTER_STATE">
                            <liebherr-device-state [device]="element"></liebherr-device-state>
                        </ng-container>
                        <ng-container *ngSwitchCase="COLUMNS.FW_TARGET_VERSION">
                            {{ element.fwUpdateInfo?.downloadVersion || '-' }}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </liebherr-table-container>

    <liebherr-no-data *ngIf="data?.devices.length === 0 && !data?.loading"></liebherr-no-data>
    <mat-paginator (page)="routerService.setPageParams($event)" [length]="data?.count" [pageSize]="data?.filterParams?.rowLimit" [pageIndex]="data?.filterParams?.page"></mat-paginator>
</ng-container>
